<template>
  <div class="app-centered-form">
    <app-loading :visible="loading" />
    <form class="md-layout from-box" v-on:keyup.enter="addOrganization">
      <md-card class="md-layout-item md-size-250 md-small-size-250">
        <organization-form-fields v-model="org" :error-message="validationError" />
        <md-card-actions>
          <md-button class="md-raised md-primary" v-on:click="addOrganization" v-lang.add v-if="canManage"></md-button>
          <md-button class="md-raised"
            :to="{ name: 'OrganizationListPage', query: getBackQuery() }">
            <span v-lang.back></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import OrganizationService from '@/common/services/organization'
import OrganizationFormFields from './FormFields.vue'
import AppLoading from '@/components/ui/AppLoading.vue'
import HasLoading from '@/mixins/HasLoading.mixin'
import Auth from '@//common/auth/index.js'
import ValidateMixin from '@/components/organizations/Validate.mixin'

export default {
  name: 'OrganizationAddForm',
  components: {
    OrganizationFormFields,
    AppLoading
  },
  mixins: [
    HasLoading,
    ValidateMixin
  ],
  data () {
    return {
      // required: null,
      hasMessages: false,
      /** @type {Organization} */
      org: {
        parentId: this.getQueryParentId(),
        officialName: '',
        shortName: ''
      },
      validationError: '',
      canManage: Auth.CanManageOrgs()
    }
  },
  watch: {
    org: {
      deep: true,
      handler () {
        this.hideErrors()
      }
    }
  },
  methods: {
    getQueryParentId () {
      return this.$route.query.parent_id
    },
    getBackQuery () {
      const query = this.$route.query
      if (query.search_term) {
        delete query.parent_id
      }

      return query
    },
    addOrganization () {
      const validationErrors = this.validate(this.org)

      if (validationErrors.length === 0) {
        this.startAppLoading()

        OrganizationService.Post(this.org)
          .then(() => {
            this.org.officialName = ''
            this.org.shortName = ''
            this.$success(this.translate('successfulAddingOrganization'), 5000)
            this.addOrganizationBack()
          })
          .catch(error => {
            if (error.response.status === 400) {
              this.validationError = error.response.data.message
            } else {
              this.$httpError.handle.call(this, error)
            }
          })
          .then(() => {
            this.finishAppLoading()
          })
      } else {
        this.validationError = this.$errorsToString(validationErrors)
      }
    },
    addOrganizationBack () {
      this.$router.push({
        name: 'OrganizationListPage',
        query: this.getBackQuery()
      })
    },
    hideErrors () {
      this.validationError = ''
    }
  }
}
</script>

<style lang="scss" scoped>
#loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/organizations/AddForm.vue